import report from "@/components/common/i18n/storeFeedback/report";

export default {
    zh: {
        restaurantsProductsInfo: "餐厅&产品基本信息",
        complaintInfo: "投诉基本信息",
        problemFirstCheckInfo: "问题初检信息",
        feedbackNo: "单据编号",
        storeNo: "餐厅国际编号（7位）",
        storeName: "餐厅国际名称",
        creator: "填表人",
        createDate: "餐厅提交日期",
        creatorTelephone: "填表人联系电话",
        dcName: "发货DC",
        supplier: "供应商",
        materialCode: "货号",
        materialName: "产品名称",
        feedbackChannel: "反馈渠道",
        consumeType: "消费类型",
        isDirectSale: "是否直营",
        status: "问题报告状态",
        feedbackStatus: "问题报告状态",
        reportType: "报告类型",
        city: "质量问题发生的城市",
        receiveDate: "餐厅接货日期",
        productionDate: "产品生产日期",
        productDate: "生产日期",
        SubmitDate: '提交日期',
        expirationDate: "产品保质期",
        lotNumber: "生产批号",
        productNum: "问题产品数量",
        productUnit: "问题产品数量单位",
        source: "选择问题反馈的来源",
        productStatus: "问题产品状态",
        haveCompensated: "是否发生用餐者赔偿",
        compensateInfo: "赔偿内容",
        describeProblem: "请详细描述发生问题",
        description: "描述",
        boxPhoto: "外箱照片(含生产日期和供应商名称)",
        problemProductPhoto: "问题产品照片",
        otherPhotos: "其他照片",
        photosDescription: "照片要求说明",
        complaintType1: "投诉分类1",
        complaintType2: "投诉分类2",
        complaintType3: "投诉分类3",
        problemLevel: "问题等级",
        complaintType: "投诉类型",
        finalResponsibleParty: "责任方",
        deadline: "要求完成时间",
        isRepeat: "是否重复",
        isLto: "是否LTO",
        relateType: "相关方判断",
        cc: "CC抄送人",
        mailContent: "邮件内容",
        hours: "小时",
        selectSuspendFeedback: "请选择需要中止的反馈单",
        suspendFeedbackError: "只有草稿状态的反馈单才可以中止",
        selectCopyFeedback: "请选择需要复制创建的反馈单",
        pleaseFillInReturnReason: "请填写退回原因",
        debitMonth: "月份",
        debitNumber: "扣账数量(箱)",
        supDebitNum: "供应商扣账箱数",
        dcDebitNum: "DC承担箱数",
        handleUser: "反馈单处理人",
        supplierCostTime: "供应商调查花费时间(小时)",
        onlyDraftDeleted: '只有草稿状态的才可删除',
        auditor: '审批人',
        ccStore: 'CC抄送人（门店）',
        suspendReason: '中止原因',
        relatedParties: '相关方涉及',
        relatedPartiesOther: '相关方涉及其他',
        fcRemarks: '质量反馈中心备注',
        report: report.zh,
    },
    en: {
        createDate: "Restaurant submission date",
        createReport: "Create Report",
        feedbackDetail: "Store Feedback Order Detail",
        finalDebitInfo: "Final Debit Info",
        feedbackNo: "Feedback No",
        feedbackStatus: "Feedback Status",
        reportNo: "Report No",
        reportType: "Report Type",
        haveQuestion: "Have Question",
        questionStatus: "Question Status",
        remark: "Remark",
        receiveDate: "Receive Date",
        deadline: "Deadline",
        haveRejected: "Have Rejected",
        sampleHandleMethod: "Sample Handle Method",
        needDebit: "Need Debit",
        debitUnit: "Debit Unit",
        complaintType1: "Complaint classification 1",
        complaintType2: "Complaint classification 2",
        complaintType3: "Complaint classification 3",
        problemLevel: "Problem Level",
        complaintType: "投诉类型",
        finalResponsibleParty: "责任方",
        canContinue: "Can Continue",
        responsibleParty: "Responsible Party",
        basicInfo: "Basic Info",
        reportDetail: "Report Detail",
        treatment: "Treatment",
        supplierAnalysis: "Supplier Analysis",
        CQSAnalysis: "CQS Analysis",
        sign: "Auditor Sign",
        description: "Description",
        attachment: "Attachment",
        pleaseFillInRejectReason: "Please Fill In Reject Reason",
        auditPass: 'Audit Pass',
        auditReject: 'Audit Reject',
        questionOfStore: 'Question of Store',
        answerOfFBC: 'Answer of Feedback Center',
        pleaseFillInReturnReason: "Please Fill In Return Reason",
        debitNumber: 'Debit Number',
        debitMonth: "Month",
        supDebitNum: "Number of boxes debited by suppliers",
        dcDebitNum: "Number of DC debit boxes",
        handleUser: "Feedback sheet handler",
        supplierCostTime: "Supplier survey time (hours)",
        materialCode: "Item number",
        onlyDraftDeleted: 'Only those in draft status can be deleted',
        auditor: 'Approved by',
        ccStore: 'CC CC (store)',
        relatedParties: 'Related parties involved',
        relatedPartiesOther: 'Other parties involved',
        fcRemarks: 'Comments of quality feedback Center',
        report: report.en,
    }
}